export var ERROR_EXCEPTION = {
  VALIDATION_ERROR: 'VALIDATION_ERROR'
};